import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import type { FC, ReactNode } from 'react';
import type { RootState } from '../../store/store';
import { getFirstAllowedRoute } from '@utils/navigation';
import { BROWSER_ROUTES } from '@constants/browser.routes';

interface GuestGuardProps {
  children: ReactNode;
}

const GuestGuard: FC<GuestGuardProps> = ({ children }) => {
  const { isAuthenticated, user } = useSelector((state: RootState) => state.user);
  if (isAuthenticated) {
    const firstAllowed =
      getFirstAllowedRoute(user?.permissions || [], {
        roles: user?.roles,
        userTypeName: user?.userType?.name,
      }) ?? BROWSER_ROUTES.DASHBOARD;
    return <Navigate to={firstAllowed} replace />;
  }
  return <>{children}</>;
};

export default GuestGuard; 